<template>
  <div id="visual-podcasts-app" class="admin-layout">
    <div class="container-fluid p-0">
      <div class="row m-0">
        <div class="w-50" v-if="showSidebar">
          <div class="admin-layout__sidebar min-h-screen relative w-full">
            <div class="h-full fixed h-full w-50 bg-gray-900">
              <SidebarMenu v-if="$route.name" />
              <a
                class="block pl-6 text-gray-600 bottom-0 absolute"
                href="https://www.ondealte.com/"
                target="_blank"
              >
                <OndeAlte class="mb-3 fill-current" />
                <div class="mb-6" style="font-size: 12px;">
                  Powered by Onde Alte
                </div>
              </a>
            </div>
          </div>
        </div>
        <div class="col-1/x">
          <div class="admin-layout__content  min-h-screen">
            <main class="admin-layout__main">
              <router-view />
            </main>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="admin-layout__template flex flex-row min-h-screen"></div> -->
  </div>
</template>

<script>
/** Components */
import SidebarMenu from '@/components/SidebarMenu.vue'
import OndeAlte from '@/assets/icons/ondealte.svg'

export default {
  components: {
    SidebarMenu,
    OndeAlte,
  },

  computed: {
    showSidebar() {
      const disallowedRoutes = ['Root', 'Preview']

      return (
        !disallowedRoutes.includes(this.$route.name) &&
        this.$route.params.tenant &&
        this.$isAuthenticated(this.$route)
      )
    },
  },
}
</script>

<style lang="scss">
.admin-layout {
  @include e(content) {
    flex-basis: 0;
  }
}
</style>
